var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0.91735 12.0771C0.947979 11.8014 0.963294 11.6636 1.005 11.5347C1.042 11.4205 1.09428 11.3117 1.16041 11.2114C1.23496 11.0983 1.33302 11.0003 1.52914 10.8042L10.3333 1.99998C11.0697 1.2636 12.2636 1.2636 13 1.99998C13.7364 2.73636 13.7364 3.93027 13 4.66665L4.19581 13.4708C3.99969 13.6669 3.90163 13.765 3.78858 13.8396C3.68829 13.9057 3.57952 13.958 3.46522 13.995C3.33639 14.0367 3.19856 14.052 2.9229 14.0826L0.666656 14.3333L0.91735 12.0771Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditIcon);
export default __webpack_public_path__ + "static/media/image-edit-Icon.a67f56caed5d28294e9647beb921ac81.svg";
export { ForwardRef as ReactComponent };